<template>
  <div class="dialog-wrap">
    <el-dialog
      title="进度日程"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      @close="handleClose"
      append-to-body
    >
      <el-form
        class="form"
        :model="dataForm"
        :rules="rules"
        ref="dataForm"
        label-width="100px"
      >
        <el-form-item
          label="定时"
          prop="is_timer"
        >
          <el-radio-group v-model="dataForm.is_timer">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="定时时间"
          prop="timer_time"
          v-if="dataForm.is_timer==1"
        >
          <el-date-picker
            v-model="dataForm.timer_time"
            type="date"
            placeholder="请选择日期时间"
            style="width:100%"
            clearable
            value-format="timestamp"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item
          label="发布人"
          prop="publish_user"
        >
          <el-input
            v-model="dataForm.publish_user"
            placeholder="请输入发布人"
          ></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input
            v-model="dataForm.remark"
            type="textarea"
            placeholder="请输入备注"
          ></el-input>
        </el-form-item>
      </el-form>

      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="handleClose">取 消</el-button>
        <el-button
          type="primary"
          @click="handleSubmit"
        >确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>


import { mediapublishUpdate, mediapublishOne, mediapublishstatusUpdate } from "@/api/select";
import { getStorage } from "@/utils/helper";


export default {
  components: {

  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    content: {
      type: Object,
      default: () => {
        return null
      }
    },
  },
  data() {
    return {
      dialogVisible: this.visible,
      dataForm: {
      },
      rules: {
        account_id: [{ required: true, message: '请选择账号', trigger: 'blur' }],
        topic_id: [{ required: true, message: '请选择选题', trigger: 'blur' }],
        writing_id: [{ required: true, message: '请选择文案', trigger: 'blur' }],
        is_timer: [{ required: true, message: '请是否定时', trigger: 'blur' }],
        is_first: [{ required: true, message: '请是否首条', trigger: 'blur' }],
        timer_time: [{ required: true, message: '请选择定时时间', trigger: 'blur' }],
        publish_user: [{ required: true, message: '请输入发布人', trigger: 'blur' }],
      },

    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
    },
    content(val) {
      if (val) {
        this.fetchDetail()
      }
    }
  },
  methods: {
    fetchDetail() {
      mediapublishOne({ id: this.content.id }).then(res => {
        this.dataForm = res
        this.dataForm.publish_user = getStorage('admin_user').nickname
      })
    },
    handleSubmit() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          let query = {
            id: this.dataForm.id,
            account_id: this.dataForm.account_id,
            topic_id: this.dataForm.topic_id,
            writing_id: this.dataForm.writing_id,
            remark: this.dataForm.remark,
            publish_user: this.dataForm.publish_user,
            is_timer: this.dataForm.is_timer,
            timer_time: this.dataForm.timer_time,
            is_first: this.dataForm.is_first,
          }
          mediapublishUpdate(query).then(res => {
            let query_other = {
              id: this.dataForm.id,
              status: 1,
            }
            mediapublishstatusUpdate(query_other).then((res1) => {
              this.$message.success(`创建成功`)
              this.$refs['dataForm'].resetFields()
              this.$emit('submit')
              this.handleClose()
            });

          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },

    handleClose() {
      this.$emit('close')
    },


  }
}
</script>

<style lang="less" scoped>
</style>
